module.exports = __webpack_public_path__ + "images/emoji/id.351a50943b420dedda4f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/id.png
// module id = i2eZ
// module chunks = 24